/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconSword = createReactComponent("outline", "sword", "IconSword", [["path", { "d": "M20 4v5l-9 7l-4 4l-3 -3l4 -4l7 -9z", "key": "svg-0" }], ["path", { "d": "M6.5 11.5l6 6", "key": "svg-1" }]]);

export { IconSword as default };
//# sourceMappingURL=IconSword.mjs.map
